

export const FREEZE = 'Freeze';

export const ANR = 'ANR';

export const TS_UUID = 'TS_UUID';

export const JAVA_UUID = 'JAVA_UUID';

export const BASE_INFO = '基础信息';

export const CUSTOM_DIMENSIONS = '自定义维度';

export const CUSTOM_FIELDS = '自定义字段';

export const PAGE_TRACK = '页面跟踪';

export const FPS = 'FPS';

export const HANG_RATE = '挂起率';

export const DROP_FRAME_RATE = '卡顿率';

// 小程序
export const MINI_PROGRAM_ERROR_NAME = '错误监控';
export const MINI_PROGRAM_API_NAME = 'API监控';
export const MINI_PROGRAM_STATIC_NAME = '静态资源';
export const MINI_PROGRAM_LAUNCH_NAME = '启动性能';
export const MINI_PROGRAM_PERF_NAME = '页面性能';
export const MINI_PROGRAM_RUNTIME_NAME = '运行性能';
export const MINI_PROGRAM_PV_NAME = '页面访问';
export const MINI_PROGRAM_EVENT_NAME = '自定义事件';
export const MINI_PROGRAM_CUSTOM_NAME = '自定义测速';
export const MINI_PROGRAM_LOG_NAME = '日志';

export const MINI_PROGRAM_API_TIMING = '耗时分析';
export const MINI_PROGRAM_API_DIMENSION = '多维下钻';
